<template>
  <div>
    <InventoryPageHeader>
        <template #title>
            <i class="fas fa-building mr-2 text-primary"></i>Companies
        </template>
        <template #search>
            <b-form-input v-model="search" placeholder="Search company..." size="sm" @input="applyFilters" />
        </template>
        <template #actions>
            <base-button size="sm" type="primary" @click="showAddCompanyModal = true">
            <i class="fas fa-plus"></i> Add Company
            </base-button>
        </template>
        </InventoryPageHeader>

    <b-container fluid class="mt--6">
      <div class="d-flex justify-content-end mb-2">
        <b-button size="sm" variant="outline-secondary" @click="showFilters = !showFilters">
          <i class="fas fa-filter"></i> Filter
          <i :class="showFilters ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-1"></i>
        </b-button>
      </div>

      <transition name="slide-fade">
        <div v-if="showFilters" class="card card-shadow mb-3">
          <div class="card-body py-2 px-3">
            <div class="filter-group">
              <label class="form-control-label small font-weight-bold text-uppercase text-muted">Has Devices</label>
              <b-form-checkbox-group v-model="hasDevicesFilter" :options="['Has Devices', 'No Devices']" @change="applyFilters" />
              <div class="active-filters mt-1">
                <b-badge v-for="f in hasDevicesFilter" :key="f" pill variant="info" class="mr-1" @click="removeHasDevicesFilter(f)" style="cursor:pointer;">
                  {{ f }} <i class="fas fa-times ml-1"></i>
                </b-badge>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <b-card no-body class="card-shadow">
        <b-card-header><i class="fas fa-list mr-2"></i>Company List</b-card-header>
        <b-card-body class="p-0 table-responsive">
          <el-table :data="filteredCompanies" @row-click="goToDetail" row-class-name="cursor-pointer" style="width:100%;" empty-text="No companies found">
            <el-table-column label="Company Name" sortable>
              <template slot-scope="{ row }">
                <router-link :to="`/companies/${encodeURIComponent(row)}`" class="text-primary font-weight-bold">{{ row }}</router-link>
              </template>
            </el-table-column>
            <el-table-column label="Devices Currently Held">
              <template slot-scope="{ row }">
                <b-badge variant="info">{{ deviceCount(row) }}</b-badge>
              </template>
            </el-table-column>
            <el-table-column label="" width="50">
              <template slot-scope="{ row }">
                <div @click.stop="confirmDeleteCompany(row)">
                  <base-button size="sm" type="outline-danger" icon>
                    <i class="fas fa-trash-alt"></i>
                  </base-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </b-card-body>
      </b-card>

      <!-- ADD COMPANY MODAL -->
      <modal :show="showAddCompanyModal" @close="showAddCompanyModal = false">
        <template v-slot:header><h5>Add New Company</h5></template>
        <b-form-group label="Company Name">
          <b-form-input v-model="newCompanyName" placeholder="Enter company name..." @keyup.enter="addCompany" />
        </b-form-group>
        <template v-slot:footer>
          <base-button type="outline-secondary" @click="showAddCompanyModal = false">Cancel</base-button>
          <base-button type="primary" :disabled="!newCompanyName.trim()" @click="addCompany">Add Company</base-button>
        </template>
      </modal>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import InventoryPageHeader from '@/components/InventoryPageHeader.vue'

export default {
  name: 'CompanyList',
    components: { InventoryPageHeader },

  data() {
    return {
      search: '',
      showFilters: false,
      hasDevicesFilter: [],
      showAddCompanyModal: false,
      newCompanyName: ''
    }
  },
  computed: {
    ...mapState('inventory', ['companies', 'devices']),
    filteredCompanies() {
      let list = this.companies
      if (this.search) {
        const q = this.search.toLowerCase()
        list = list.filter(c => c.toLowerCase().includes(q))
      }
      if (this.hasDevicesFilter.length === 1) {
        if (this.hasDevicesFilter[0] === 'Has Devices') {
          list = list.filter(c => this.devices.some(d => d.currentLocation === c))
        } else if (this.hasDevicesFilter[0] === 'No Devices') {
          list = list.filter(c => !this.devices.some(d => d.currentLocation === c))
        }
      }
      return list
    }
  },
 async mounted() {
  await Promise.all([
    this.loadCompanies(),
    this.loadDevices()
  ])
},
  methods: {
...mapActions('inventory', {
  loadCompanies: 'loadCompanies',
  doAddCompany: 'addCompany',      // ← renamed
  deleteCompany: 'deleteCompany'
}),
    deviceCount(company) {
      return this.devices.filter(d => d.currentLocation === company).length
    },
    goToDetail(row) {
      this.$router.push({ name: 'companyDetail', params: { name: row } })
    },
    applyFilters() {},
    removeHasDevicesFilter(f) {
      this.hasDevicesFilter = this.hasDevicesFilter.filter(v => v !== f)
      this.applyFilters()
    },
addCompany() {
  const name = this.newCompanyName.trim()
  if (!name) return
  this.doAddCompany(name)          // ← use renamed action
  this.newCompanyName = ''
  this.showAddCompanyModal = false
},
    async confirmDeleteCompany(name) {
      if (!name) return
      if (!confirm(`Delete company "${name}"? This will not delete its devices.`)) return
      try {
        await this.deleteCompany(name)   // calls Vuex action
        this.loadCompanies()
      } catch (e) {
        alert('Delete failed: ' + e.message)
      }
    }
  }
}
</script>